import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

type MenuItemProps = React.ComponentProps<typeof MenuItem>;

interface Props<T> {
    value?: T;
    icon?: React.ElementType;
    primaryText?: string;
    onClick?: (value: T) => void;
}

function MenuListItem<T>(
    props: React.PropsWithChildren<Props<T>> & Omit<MenuItemProps, 'onClick'>
) {
    // I want to get menuProps but eslint is mad that I don't also use the other props
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { value, icon, primaryText, onClick, children, ...menuProps } = props;
    const Icon = props.icon;

    const handleClick = () => {
        props.onClick(props.value);
    };

    return (
        <MenuItem
            sx={{ padding: '6px 24px 6px 16px' }}
            onClick={handleClick}
            {...menuProps}
        >
            {Icon && (
                <ListItemIcon>
                    <Icon sx={{ minWidth: '29px' }} />
                </ListItemIcon>
            )}
            <ListItemText sx={{ color: '#000' }}>{props.children}</ListItemText>
        </MenuItem>
    );
}

export default MenuListItem;
